import { Box, styled } from '@mui/material';

export const BundleCourseCardInstructorBox = styled(Box)(
  ({ theme }) => `
  padding-right: 12px;
  display: flex;
  flex-direction: row;

  ${theme.breakpoints.down('md')} {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  .avatar-instructor {
    border: solid 2px white;
    height: 25.63px;
    width: 25.63px;

    ${theme.breakpoints.down('md')} {
      display: none;
    }
  }

  .instructor-info {
    color: ${theme.palette.textV2.primary};
    margin-left: 12px;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;

    ${theme.breakpoints.down('md')} {
      color: rgba(103, 103, 103, 1);
      margin-left: 0px;
      line-height: 14px;
      font-family: 'Lanna';
    }
  }
`,
);
